export { preloadEmbedData } from '../src/preloadEmbedData';
